// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { DialogContent } from '@material-ui/core';

// Internal Dependencies
import MText from '../../../common/MText';
import Colours from '../../../../styles/colours';
import { ParseHtmlIntoReactCom } from '../../../../common/util';

const DeleteContent = ({ modal }) => {
  const qnsCom = ParseHtmlIntoReactCom(modal.qns);
  const answerCom = ParseHtmlIntoReactCom(modal.answer);

  return (
    <DialogContent>
      <div className="d-flex flex-column mx-3" style={{ color: Colours.Crimson, fontSize: 12 }}>
        <div className="d-flex">
          <MText bold colour={Colours.Crimson} size={12} text="Q:" />
          <div className="ml-2" style={{ paddingTop: 1 }}>
            {qnsCom}
          </div>
        </div>
        <div className="d-flex">
          <MText bold colour={Colours.Crimson} size={12} text="A:" />
          <div className="ml-2" style={{ paddingTop: 1 }}>
            {answerCom}
          </div>
        </div>
      </div>
    </DialogContent>
  );
};

DeleteContent.propTypes = {
  modal: PropTypes.shape(Object).isRequired,
};
export default DeleteContent;
